import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import {
  AbstractContentComponent,
  ResponsiveInput,
} from '@epicuro-next/elements/content-core';
import { PulseContentElement } from '@epicuro-next/elements/core';
import { BehaviorSubject } from 'rxjs';

const selector = 'pcn-page-menu';

@PulseContentElement({ selector })
@Component({
  selector,
  templateUrl: './page-menu.component.html',
  styleUrls: ['./page-menu.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageMenuComponent
  extends AbstractContentComponent
  implements OnInit, OnDestroy
{
  @ResponsiveInput({ defaultValue: 'transparent', cssVariable: true })
  public wideBackgroundColor: string;

  @ResponsiveInput({ isBoolean: true })
  public wrap: boolean;

  public isMobile$ = atxIsMobile$;
  public show$ = new BehaviorSubject(false);

  public open() {
    this.show$.next(true);
  }

  public close() {
    this.show$.next(false);
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }
}
